export const CAR = Object.freeze({ mass:1280, radius:.31, finalDrive:3.7, gears:[0,3.35,2.12,1.52,1.16,.93,.77], idle:950, redline:6900, damage:8300, inertia:.24, clutchCapacity:390, launchRpm:3200 });
const TAU=2*Math.PI;
export const rpmToOmega=rpm=>rpm*TAU/60;
export const omegaToRpm=w=>w*60/TAU;
export function torque(rpm){return Math.max(0,245-95*((rpm-4200)/4200)**2);}
export function createVehicle(){return {speed:0,distance:0,rpm:CAR.idle,gear:1,clutch:1,engagement:0,throttle:0,stalled:false,broken:false,stallTime:0,jerk:0,cut:false,load:0};}
export function wheelRpm(v,gear=v.gear){return omegaToRpm(v.speed/CAR.radius*CAR.gears[gear]*CAR.finalDrive);}
export function selectGear(v,gear){
  if(!Number.isInteger(gear)||gear<0||gear>6||v.broken)return 'invalid';
  if(v.clutch<.95)return 'grind';
  if(v.gear===gear)return null;
  v.gear=gear;
  return gear?'shift':'neutral';
}
export function restart(v){if(v.stalled&&v.clutch>.95&&!v.broken){v.stalled=false;v.rpm=CAR.idle;v.stallTime=0;return true;}return false;}
export function stepVehicle(v,dt,{revving=false,braking=false}={}){
  if(v.broken)braking=true;
  const target=1-v.clutch;
  v.engagement+=Math.max(-dt*20,Math.min(dt*5,target-v.engagement));
  const ratio=CAR.gears[v.gear]*CAR.finalDrive;
  const roadOmega=v.speed/CAR.radius*ratio;
  const w=rpmToOmega(v.rpm);
  const cut=v.rpm>CAR.redline;
  const throttle=braking||v.stalled?0:revving?Math.max(.08,Math.min(1,.3+(CAR.launchRpm-v.rpm)*.002)):v.clutch>.5?.08:1;
  v.throttle+=Math.max(-dt*10,Math.min(dt*3,throttle-v.throttle));
  const idleControl=v.rpm<CAR.idle?Math.min(110,(CAR.idle-v.rpm)*.4):0;
  const engine=v.stalled?0:(cut?0:torque(v.rpm)*v.throttle)+idleControl-22-w*.025;
  const capacity=CAR.clutchCapacity*v.engagement;
  // Bounded coupling transfers equal/opposite torque; stiffness is stable at 120 Hz.
  const clutchTorque=ratio?Math.max(-capacity,Math.min(capacity,(w-roadOmega)*8)):0;
  const force=Math.max(-8500,Math.min(8500,clutchTorque*ratio*.9/CAR.radius));
  const drag=v.speed>0?145+.40*v.speed*v.speed:0;
  const previous=v.speed;
  v.speed=Math.max(0,v.speed+(force-drag-(braking?10000:0))/CAR.mass*dt);
  v.distance+=(previous+v.speed)*.5*dt;
  let nextW=Math.max(0,w+(engine-clutchTorque)/CAR.inertia*dt);
  if(braking||v.stalled)nextW=Math.max(0,nextW-dt*12);
  v.rpm=omegaToRpm(nextW);
  v.cut=cut;
  v.load=Math.min(1,Math.abs(clutchTorque)/CAR.clutchCapacity);
  v.jerk+=(Math.abs(force/CAR.mass)-v.jerk)*Math.min(1,dt*15);
  if(!revving&&!braking&&!v.stalled&&v.rpm<600){v.stallTime+=dt;if(v.stallTime>.22){v.stalled=true;v.rpm=0;}}else v.stallTime=0;
  // Engine braking overspeed is distinct from the normal ignition limiter.
  if(!revving&&!braking&&ratio&&v.engagement>.3&&wheelRpm(v)>CAR.damage&&v.rpm>CAR.damage)v.broken=true;
  if(v.stalled)v.rpm=Math.max(0,v.rpm-dt*1800);
}
